import actionTypes from './actionTypes';

const requestLeaders = (args) => ({
    type: actionTypes.REQUEST_LEADERS,
    payload: args,
});

const leadersResponse = (success, errors, response) => ({
    type: actionTypes.LEADERS_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

export default {
    requestLeaders,
    leadersResponse,
};
